import store from "./store";

/**
 *
 * @param {*} select - function has store as argument and returns its value
 * eg: `state => (state.some.deep.property)`
 */

export function watchState(select, callback) {
    let currentValue = select(store.getState());
    function handleChange() {
        let previousValue = currentValue;
        currentValue = select(store.getState());

        if (previousValue !== currentValue) {
            callback(currentValue);
        }
    }

    const unsubscribe = store.subscribe(handleChange);
    return unsubscribe;
}
